const capValueAtZero = value => value > 0 ? value : 0;
export const deriveGapChangeIndicatorValues = ({
  currencyCode,
  change,
  currentAmount,
  isTooEarlyInPeriod,
  previousAmount
}, goal) => {
  const gapCurrentAmount = capValueAtZero(goal - currentAmount);
  const gapPreviousAmount = capValueAtZero(goal - previousAmount);
  const gapChange = (gapCurrentAmount > 0 ? change : gapPreviousAmount) * -1;
  const gapPercentChange = gapChange / gapPreviousAmount * 100;
  return {
    currencyCode,
    change: gapChange,
    currentAmount: gapCurrentAmount,
    isTooEarlyInPeriod,
    percentChange: gapPercentChange,
    previousAmount: gapPreviousAmount
  };
};